module.exports = __webpack_public_path__ + "fonts/db_helvethaica_x_li_v3.2-webfont.7b8c17df.woff";